module.exports = __webpack_public_path__ + "static/img/Jack_Gunston_desktop.64e200f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack_Gunston_desktop.jpg
// module id = hf73
// module chunks = 0